import React from 'react';

import LinearGradient from 'react-native-linear-gradient';
import {RFValue} from 'react-native-responsive-fontsize';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import {useTheme} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

export function ClubeCardShimmer() {
  const theme = useTheme();
  return (
    <ShimmerPlaceHolder
      style={{width: '100%', height: 210, borderRadius: RFValue(12)}}
      shimmerColors={theme.colors.shimmer_placeholder}
    />
  );
}
